import styled, { css } from "styled-components";

export const StepBtnsWrap = styled.div`
  width: 100%;
  display: flex;
  /* margin: 0 0 15px;

  @media (min-width: 1440px) {
    margin: 0 0 24px;
  } */

  .step-btn {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    flex-grow: 1;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    font-weight: 400;
    padding: 10px;
    text-align: center;
    color: #7f8594;
    text-transform: capitalize;
    /* border-bottom: 2px solid #e6e7ec; */
    transition: all ease-in-out 0.4s;
    background: var(--white);
    position: relative;

    @media (min-width: 1440px) {
      font-size: 16px;
      line-height: 21px;
      padding: 20px 10px;
    }

    &.edit {
      /* underline base */
      &::before {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #2380f3 0%, #41cffd 100%);
        z-index: 3;
        transition: width 0.35s ease-in-out;
      }

      /* expand line on active / hover */
      &.active::before {
        width: 100%;
      }

      &.clickable {
        &:hover {
          transform: none;
        }
      }
    }

    &.disabled {
      cursor: not-allowed;
    }

    .tick {
      font-size: 20px;
      color: #0da06a;
      visibility: hidden;
      opacity: 0;
      transition: 0.3s;

      &.active {
        visibility: visible;
        opacity: 1;
      }
    }

    &.active {
      font-weight: 600;
      color: var(--blue);
      /* border-color: var(--blue); */
      background: #e9f3fd;
    }
    &.completed {
      border-color: var(--blue);
    }

    &.clickable {
      cursor: pointer;
      pointer-events: auto;
      opacity: 1;

      &:hover {
        color: var(--primary-color);
        transform: scale(1.02);
      }
    }
  }
`;
export const MappingHolder = styled.div`
  position: relative;
  padding: 0 0 80px;

  .col-maping {
    .head {
      font-size: 16px;
      line-height: 20px;
      color: #9d9d9d;
      padding: 25px 38px 0;
      margin: 0 0 25px;

      .heading {
        display: block;
        font-size: 25px;
        line-height: 28px;
        font-weight: 500;
        color: #313131;
        margin: 0 0 5px;
      }
    }
  }

  .col-wrap {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
  }

  .btn-holder {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);

    &::before {
      display: none;
      content: "";
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #f4f4f4 100%
      );
    }

    .btn-wrap {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 300px;
    }
  }
`;

export const StyledCompaignTask = styled.div`
  width: 100%;
  background: var(--white);
  overflow: hidden;
  position: relative;
  padding: ${({ $noPadding }) => ($noPadding ? "0" : "0 0 73px")};


  .steps-holder {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    height: calc(100vh - 182px); 
    padding: 0 20px;
    overflow: hidden;
    background: var(--white);
    overflow: auto;
        transition: all 0.350s ease-in-out;
        @media (min-width: 1440px){
    height: calc(100vh - 222px); 

        }
    
   .trial-banner-visible & {
        height: calc(100dvh - 224px);
        @media (min-width: 1440px){
          height: calc(100dvh - 264px);

        }
      }
    &.sequence {
      max-width: 100%;
      padding: 0;
      /* margin: -24px 0 0; */
    }
  }

  .column-wrap {
    display: flex;
    flex-grow: 1;
    gap: 20px;

    @media (min-width: 1440px) {
      gap: 30px;
    }

    .left-col {
      flex-grow: 1;
      width: 50%;
    }

    .right-col {
      flex-shrink: 0;
      width: 300px;

      @media (min-width: 1200px) {
        width: 340px;
      }
      @media (min-width: 1440px) {
        width: 410px;
      }
    }
  }

  .col-maping {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;

    .head {
      text-align: center;
      margin: 0 0 25px;
    }
  }

  .add-attachment {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #6f749a;
    /* cursor: pointer; */
    margin: 0 0 20px;

    span {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-style: italic;
      text-decoration: underline;
    }
  }

  .goBack {
    position: absolute;
    top: 50px;
    left: 20px;
  }

  .no-leads-loader {
    height: calc(100vh - 90px);
  }

  .success-loader {
    max-width: 200px;
    margin: 0 auto;
  }

  .head {
    width: 100%;
    margin: 0 0 20px;

    > div {
      width: 100%;
    }

    .heading {
      display: block;
      font-size: 22px;
      line-height: 25px;
      font-weight: 500;
      color: var(--text-color-50);
      margin: 0 0 10px;

      @media (min-width: 1440px) {
        font-size: 25px;
        line-height: 28px;
      }
    }

    .text {
      display: block;
    }
  }

  .task-title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    display: block;
    margin-bottom: 10px;
    @media (min-width: 768px) {
      font-size: 26px;
      line-height: 30px;
    }
  }

  .task-completed {
    text-align: center;
    p {
      margin-bottom: 15px;
    }
    .title {
      color: var(--primary);
      font-weight: 500;
      font-size: 25px;
      line-height: 29px;
      display: block;
      margin-bottom: 10px;
    }
    .btn-loader {
      max-width: 300px;
      width: 100%;
      margin: 0 auto;
    }
  }

  .btn-holder {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: ${({ $flexEnd }) =>
    $flexEnd ? "flex-end" : "space-between"};
    gap: 10px;
    padding: 10px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);
    
    @media (min-width: 1440px){
      padding: 15px;
    }
    
    &::before {
      display: none;
      content: "";
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #f4f4f4 100%
      );
    }

    .btn-wrap {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 300px;
    }

    button {
      width:100% ;
      max-width:120px ;
      font-weight: 600;
      padding: 8px 25px;
      
      @media (min-width: 1440px){
        max-width:auto;
        padding: 11px 25px;
      }
    }
  }

  .two-col {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 20px;
    @media (min-width: 576px) {
      grid-template-columns: 1fr 1fr;
    }
    .col {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: var(--primary);
      margin-bottom: 40px;
      span {
        display: block;
        margin-bottom: 10px;
      }
      .title {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
      }
    }
  }

  .label {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  }

  .col-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: var(--text-color);
    display: block;
    margin-bottom: 15px;
  }
  .task-completed {
    position: relative;
  }

  .fetch-details-btn {
    width: 100px;
    font-size: 12px;
    line-height: 16px;
    padding: 8px 10px;
    border-radius: 60px;
  }

  .loader-wrapper {
    height: 200px;
    .loader {
      --hue: 210;
      --size: 100px;
      --border: 10px;
      --speed: 1s;
      --blur: var(--border);
    }

    .loader {
      width: var(--border);
      aspect-ratio: 1;
      background: white;
      border-radius: 50%;
      /* position: absolute; */
      --y: calc((var(--size) * -0.5) + (var(--border) * 0.5));
      transform: rotate(0deg) translateY(var(--y));
      animation: spin var(--speed) infinite linear;
    }

    .loader::before {
      content: "";
      position: absolute;
      inset: calc(var(--border) * -0.5);
      border-radius: 50%;
      background: white;
      filter: blur(var(--blur));
      z-index: -1;
    }

    .loader::after {
      content: "";
      width: var(--size);
      aspect-ratio: 1;
      position: absolute;
      top: 0%;
      left: 50%;
      translate: -50% 0;
      background: conic-gradient(
        white,
        hsl(var(--hue), 100%, 70%),
        hsl(var(--hue), 100%, 10%),
        transparent 65%
      );
      border-radius: 50%;
      mask: radial-gradient(
        transparent calc(((var(--size) * 0.5) - var(--border)) - 1px),
        white calc((var(--size) * 0.5) - var(--border))
      );
    }

    @keyframes spin {
      to {
        transform: rotate(-360deg) translateY(var(--y));
      }
    }
  }

  .progress-bar {
    width: 100%;
    height: 4px;
    position: relative;
    overflow: hidden;
    margin: 0 0 15px;
    backdrop-filter: blur(5px);
    background: #e6e7ec;
    z-index: 2;

    @media (min-width: 1440px) {
      margin: 0 0 24px;
    }
  }

  .progress-fill {
    height: 100%;
    position: relative;
    background: linear-gradient(90deg, #2380f3 0%, #24cdfe 100%);
    transition: width 0.4s ease-in-out;
    box-shadow: 0px 0px 4px 0px rgba(36, 205, 254, 1);

    &:after {
      position: absolute;
      top: -2px;
      right: -3px;
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50px;
      background: #24cdfe;
      box-shadow: 0px 0px 4px 0px rgba(36, 205, 254, 1);
    }
  }

  .edit-loading-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 150px);
  }
`;

export const TabsWrap = styled.div`
  position: relative;

  .title {
    display: block;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    margin: 0 0 10px;
    color: var(--primary);
  }

  .tabs-btns {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;

    .tabBtn {
      width: 50%;
      padding: 1px;
      border-radius: 20px;
      border: 1px solid #efefef;
      background: #fdfdfd;

      .btn-content {
        position: relative;
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 20px 16px;
        border-radius: 20px;
        text-align: left;
      }

      &.active {
        border: 1px solid rgba(49, 123, 255, 0.1);
        background: rgba(49, 123, 255, 0.1);

        .ico-tick {
          border: 1.5px solid var(--blue);

          &::before {
            display: block;
          }
        }
      }
    }

    .ico-tick {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 50px;
      border: 1.5px solid #cacaca;
      position: relative;

      &::before {
        display: none;
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 50px;
        background: var(--blue);
      }
    }

    .icon-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50px;
      border: 1px solid #efefef;
      background: var(--white);
    }

    .text-box {
      flex-grow: 1;

      .subtitle {
        display: block;
        font-size: 12px;
        line-height: 14px;
        margin: 0 0 6px;
        color: rgba(49, 49, 49, 0.5);
      }
      .title {
        display: block;
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        margin: 0;
      }
    }
  }

  .tab-content {
    margin: 0 0 20px;

    .note-box {
      width: 100%;
      font-size: 13px;
      line-height: 16px;
      font-weight: 300;
      color: #cdcdcd;
      padding: 15px 0 0;

      .text {
        color: #2783ec;
      }
    }
  }

  .content01 {
    .input-holder {
      display: flex;
      gap: 20px;
    }

    .selectwrap {
      position: relative;
    }

    .react-select__control {
      background: #fbfbfb;
    }
  }
`;

export const StyledCampaignSequence = styled.div`
  flex-grow: 1;

  .head {
    display: none;
  }

  .content-holder {
    height: 100%;
    display: flex;
    gap: 10px;
    transition: all 0.350s ease-in-out;


    @media (min-width: 1200px) {
      gap: 14px;
    }

    .steps-bar {
      width: 380px;
      flex-shrink: 0;
      color: var(--text-color-50);
      padding: 25px 13px;
      overflow: auto;
      background: #fefefe;

      @media (min-width: 1200px) {
        width: 440px;
        padding: 25px 20px;
      }
      .steps-bar-content {
        width: 100%;

        > div:last-child {
          .step-holder:last-child {
            &::before {
              display: none;
            }
          }
        }
      }
      ${({ $isAiCampaign }) =>
    $isAiCampaign &&
    css`
          display: flex;
          align-items: center;
          margin: 0 auto;
        `}

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      .step-head {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0 0 6px;

        .icon-holder {
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1b1f3c;
          background: #e8e9f1;
          border-radius: 50%;
          z-index: 1;
        }

        .title {
          display: block;
          font-size: 18px;
          line-height: 22px;
          font-style: italic;
          font-weight: 700;
        }
      }



      .step-holder {
        position: relative;
        padding: 0 0 30px;

        &:first-child {
          &::before {
            top: 25px;
          }
        }

       

        &:before {
          content: "";
          position: absolute;
          top: 0;
          bottom: -28px;
          left: 17px;
          width: 1px;
          background: #e6e7ec;
        }
        &:after {
          content: "";
          position: absolute;
          top: 25px;
          left: 10px;
          width: 16px;
          height: 16px;
          border-radius: 50px;
          background: #2783ec;
        }

        &.waiting-step {
          &:after {
            background: #0da06a;
          }
        }

        .step {
          margin-left: 34px;

          @media (min-width: 1200px) {
            margin-left: 40px;
          }

          &.day-limit {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 18px 20px;
            border-radius: 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            background: #fcfcfc;

            input {
              width: 50px;
              height: 30px;
              text-align: center;
              padding: 3px 5px;
              border-radius: 8px;
              border: 0;
              outline: none;
              box-shadow: none;
              background: rgba(49, 123, 255, 0.1);
            }
            .text {
              display: block;
              font-size: 15px;
              line-height: 19px;
              font-weight: 600;
            }
            .choose-box {
              display: flex;
              align-items: center;
              flex-grow: 1;
              gap: 5px;
              font-size: 15px;
              line-height: 19px;

              .btn-wrap {
                height: 30px;
                display: flex;
                border-radius: 8px;
                overflow: hidden;
                background: rgba(49, 123, 255, 0.1);

                button {
                  padding: 3px 8px;
                  text-transform: capitalize;

                  &.active {
                    color: var(--white);
                    background: var(--blue);
                  }
                }
              }
            }
            .btn-delete {
              display: block;
              width: 23px;
              height: 23px;
              border-radius: 4px;
              background: #f9e6e6;
            }
          }

          .variant-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 20px;
            border-radius: 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            background: var(--white);

            .wrap {
              display: flex;
              align-items: center;
              flex-grow: 1;
              gap: 10px;
            }

            .icon-holder {
              color: var(--blue);
            }

            .btn-delete {
              display: block;
              width: 23px;
              height: 23px;
              border-radius: 4px;
              background: #f9e6e6;
            }
          }

          .step-title {
            display: block;
            font-size: 14px;
            line-height: 18px;
            font-weight: 600;
            color: var(--black);
          }
          .step-subtitle {
            display: block;
            font-size: 11px;
            line-height: 13px;
            color: rgba(0, 0, 0, 0.5);
          }

          .step-name-wrap {
            margin: -1px 20px 0;
            padding: 15px;
            border-radius: 0 0 10px 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            background: var(--white);
          }

          .step-name-holder {
            display: flex;
            align-items: center;
            gap: 5px;
            position: relative;
            cursor: pointer;

            &:not(:last-child) {
              margin: 0 0 8px;
            }

            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: -15px;
              bottom: 0;
              width: 4px;
              background: var(--gray-100);
              border-radius: 0 5px 5px 0;
              visibility: hidden;
              opacity: 0;
              transition: 0.5s;
            }

            &.active {
              &:before {
                visibility: visible;
                opacity: 1;
                background: var(--blue);
              }

              .step-label {
                color: var(--blue);
                background: #eaf2ff;
              }
            }

            &:hover {
              .remove-icon {
                visibility: visible;
                opacity: 1;
                transform: translateX(0);
              }
            }

            .step-label {
              width: 23px;
              height: 23px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              font-size: 12px;
              line-height: 14px;
              color: var(--gray-300);
              background: var(--gray-250);
              border-radius: 50%;
              transition: 0.5s;
            }

            .name-holder {
              display: flex;
              align-items: center;
              flex-grow: 1;
              gap: 10px;
            }

            .step-name {
              display: block;
              font-size: 14px;
              line-height: 18px;
            }

            .remove-icon {
              visibility: hidden;
              opacity: 0;
              transition: all ease-in-out 0.3s;
              transform: translateX(10px);
              width: 16px;
              height: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--light-gray);
              border: 1px solid var(--light-gray);
              border-radius: 50%;
            }
          }
        }

        .varaint-btn-holder {
          display: flex;
          justify-content: flex-end;
          padding: 0 45px 0 0;

          .add-variant {
            font-size: 12px;
            line-height: 15px;
            font-weight: 600;
            color: var(--blue);
            padding: 6px 15px 8px;
            border-radius: 0 0 12px 12px;
            background: rgba(49, 123, 255, 0.1);
          }
        }
      }

      .add-step-holder {
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 0 0 0 40px;
        margin: 0 0 15px;

        button {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 12px;
          line-height: 16px;
          font-weight: 600;
          color: var(--blue);
          padding: 10px 15px;
          border: 1px solid #e3e3e3;
          border-radius: 10px;
          box-shadow: 0px 0px 14px 0px #0000000d;
          background: var(--white);

          .icon {
            font-size: 16px;
          }
        }
      }
    }

    .content {
      flex-grow: 1;
      background: #fcfcfc;
      border: 1px solid #d3d3d3;
      border-radius: 16px;
    }
  }
`;

export const StyledSheduleCampaign = styled.div`
  .choose-time-fields {
    display: flex;
    gap: 16px;

    .time-period {
      display: flex;
      border: 1px solid var(--blue);
      border-radius: 60px;
      overflow: hidden;

      button {
        font-size: 12px;
        line-height: 16px;
        padding: 4px 8px;

        &.active {
          background: var(--blue);
          color: var(--white);
        }
      }
    }

    .daily-limit-field {
      width: 49%;
    }
  }

  .days-list-label {
    display: block;
    color: var(--text-color-50);
    margin: 0 0 10px;
  }

  .days-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
    gap: 10px;
    padding: 12px 12px 4px;
    margin: 0 0 15px;
    border-radius: 8px;
    border: 1px solid #dedede;
    background: #fefefe;

    @media (min-width: 1200px) {
      gap: 16px;
      margin: 0 0 25px;
    }

    span {
      font-size: 13px;
      line-height: 16px;
      color: #313131;
    }
  }

  .timezone-select {
    z-index: 9999999;
  }

  .date {
    height: 42px;
    border-radius: 10px;
    background: #fefefe;
  }
`;

export const StyledCampaignSetting = styled.div`

form{
  height: calc(100vh - 310px);
      transition: all 0.350s ease-in-out;

      .trial-banner-visible & {
        height: calc(100dvh - 350px);
    }
}

  .col {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 15px;
    margin: 0 0 15px;
    border: 1px solid #efefef;
    border-radius: 10px;
    background: var(--white);
    position: relative;

    @media (min-width: 1200px) {
      padding: 20px;
      margin: 0 0 25px;
    }

    &.firs-col {
      display: block;

      .content-holder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        margin: 10px 0 6px;
      }
    }

    &::-webkit-scrollbar {
      width: 20px;
    }

    &.email-select {
      padding: 25px 20px;

      .select-placeholder {
        position: absolute;
        top: 46px;
        left: auto;
        padding: 0 0 0 15px;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
        user-select: none;
      }

      .react-select__control {
        position: static;

        .react-select__placeholder {
          display: none;
          position: absolute;
          right: 0;
          width: 200px;
        }

        .react-select__value-container {
          position: absolute;
          top: 4px;
          left: 220px;
          right: 0;
          height: 99px;
          overflow: auto;
          pointer-events: none;
          padding: 0 390px 0 0;
        }

        .react-select__multi-value {
          background: #f2f7fc;
          padding: 3px 5px;
          border-radius: 6px;
          pointer-events: all;

          .react-select__multi-value__label {
            font-size: 13px;
            line-height: 17px;
          }
        }

        .react-select__indicators {
          margin-left: auto;
        }

        .react-select__indicator {
          padding: 0;
        }

        .react-select__clear-indicator {
          display: none;
        }

        .react-select__input-container {
          position: absolute;
          right: 150px;
          width: 200px;
          overflow: auto;
        }

        .react-select__multi-value__remove {
          color: #619afe;
          cursor: pointer;
          &:hover {
            background-color: var(--gray-50);
          }
        }
      }
    }

    &.autopilot {
      .heading,
      .text {
        width: max-content;
        background: linear-gradient(
          90deg,
          #317bff 0%,
          #b74bff 50.96%,
          #fdb409 100%
        );
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        padding: 2px; /* border thickness */
        border-radius: 10px;
        background: linear-gradient(
          90deg,
          #317bff 0%,
          #b74bff 50.96%,
          #fdb409 100%
        );

        -webkit-mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;

        pointer-events: none;
      }
      .switch-holder {
        width: 100%;
        max-width: 350px;
      }
    }

    .heading {
      display: block;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      color: var(--text-color-50);
      margin: 0 0 5px;
    }

    .text {
      display: block;
      font-size: 14px;
      line-height: 18px;
      font-weight: 300;
    }

    .grd-color {
      display: block;
      text-align: center;
      font-size: 13px;
      line-height: 16px;
      font-weight: 300;
    }

    .enable-disable-tabs {
      width: 100%;
      max-width: 350px;

      button {
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
        padding: 14px 20px;
        border: 1px solid #efefef;
        border-radius: 10px 0 0 10px;
        transition: 0.3;

        &:nth-child(2) {
          border-radius: 0 10px 10px 0;
        }

        &.active {
          color: var(--white);
          border-color: var(--blue);
          background: var(--blue);
        }

        &.disabled-btn {
          cursor: not-allowed;
          opacity: 0.7;
        }
      }
    }

    .content {
      position: absolute;
      bottom: 70px;
      color: var(--white);
      background-color: var(--green);
      padding: 10px;
      border-radius: 4px;
      visibility: hidden;
      opacity: 0;
      transform: translateX(-30%) translateY(-50px);
      transition: 0.5s;
      min-width: 150px;
    }

    .content:before {
      content: "";
      position: absolute;
      width: 15px;
      height: 15px;
      background: var(--green);
      bottom: -5px;
      left: 50%;
      transform: rotate(45deg);
    }
  }

  .delivery-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 5px;

    .heading {
      margin: 0;
    }

    .tag {
      display: block;
      font-size: 12px;
      line-height: 16px;
      padding: 5px 10px;
      color: #419400;
      background: #ecf5e6;
      border-radius: 5px;
    }
  }

  .checkbox-col {
    width: 100%;
    max-width: 350px;

    span {
      font-size: 14px;
      line-height: 16px;
      font-weight: 300;
      color: #313131;
    }
  }

  .select-holder {
    width: 100%;
    max-width: 350px;
    padding: 0 78px 0 0;

    .react-select__control {
      border-radius: 10px;
      border-color: #dfdfdf;
      background: var(--white);
    }
  }

  .input-holder {
    width: 200px;

    input {
      border-color: #dfdfdf;
    }
  }
`;

export const StyledDeleteStep = styled.div`
  max-width: 450px;
  margin: 0 auto;

  .heading {
    display: block;
    font-size: 25px;
    line-height: 29px;
    color: var(--text-color-50);
    text-align: center;
    margin: 0 0 16px;
  }

  .text {
    display: block;
    text-align: center;
    margin: 0 0 25px;
  }

  .btn-holder {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
`;

export const StyledStaticSequenceVariant = styled.div`
  padding: 16px 0;
  font-size: 14px;
  line-height: 18px;
  color: #5e5e5e;

  .text {
    display: block;
    margin: 0 0 20px;
  }

  .default-message {
    white-space: pre-line;
  }

  a {
    color: var(--turquoise);
    text-decoration: underline;
  }

  .greeting {
    font-weight: 500;
    color: var(--text-color-50);
  }

  ul {
    margin: 0 0 20px 0;

    li {
      display: flex;
      align-items: center;
      gap: 5px;
      margin: 0 0 10px;
      padding: 0 0 0 15px;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        top: 6px;
        left: 0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: var(--blue);
      }
    }
  }

  .signature {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 700;
    color: var(--text-color-50);
    font-style: italic;
  }
`;

export const QuickTtips = styled.div`
  position: relative;
  width: 100%;
  color: rgba(29, 29, 29, 0.5);
  padding: 12px;
  border-radius: 20px;
  background: #fcfcfc;

  @media (min-width: 1200px) {
    padding: 20px;
  }

  .head {
    margin: 0 0 10px;

    @media (min-width: 1440px) {
      margin: 0 0 30px;
    }

    .title {
      display: block;
      font-size: 22px;
      line-height: 25px;
      font-weight: 500;
      text-transform: capitalize;
      margin: 0 0 5px;
      color: var(--black);

      @media (min-width: 1440px) {
        font-size: 25px;
        line-height: 28px;
      }
    }
  }

  .tip-list {
    height: calc(100vh - 318px);
    overflow-y: auto;
    list-style: none;
    margin: 0;
    padding: 0;
    transition: all 0.350s ease-in-out;
    
    
    .trial-banner-visible & {
      height: calc(100dvh - 361px);
      @media (min-width: 1440px){
        height: calc(100dvh - 407px);
      }
    }
    
    @media (min-width: 1440px){
      height: calc(100vh - 365px);
    }

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px;
      margin: 0 0 10px;
      border-radius: 10px;
      background: var(--white);

      @media (min-width: 1440px) {
        gap: 15px;
        padding: 16px;
        margin: 0 0 20px;
      }
    }

    .icon-box {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      padding: 5px;
      border-radius: 8px;
      background: rgba(49, 123, 255, 0.1);
    }

    .text-box {
      flex-grow: 1;
      font-size: 12px;
      color: var(--light-gray);

      @media (min-width: 1200px) {
        font-size: 14px;
      }
      @media (min-width: 1440px) {
        line-height: 21px;
      }
    }

    .title {
      display: block;
      font-size: 14px;
      line-height: 17px;
      font-weight: 500;
      color: #0d171c;

      @media (min-width: 1200px) {
        font-size: 16px;
        line-height: 19px;
      }
    }
  }

  .btn-watch {
    display: inline-block;
    font-size: 10px;
    line-height: 13px;
    font-weight: 600;
    color: #317bff;
    text-decoration: underline;
  }
`;

export const LeadsStepWrap = styled.div`
  position: relative;

  .filter-wrap {
    display: flex;
    align-items: start;
    gap: 15px;
    margin: 0 0 20px;

    .form-search {
      display: flex;
      gap: 15px;
      flex-grow: 1;
    }
    .btn-wrap {
      display: flex;
      flex-grow: 1;
      justify-content: flex-end;
      gap: 15px;
      flex-shrink: 0;
    }
  }

  .inner-wrap{
      height:calc(100vh - 292px);
        transition: all 0.350s ease-in-out;
         .trial-banner-visible & {
            height: calc(100dvh - 342px);
            }
  }

  table {
    thead {
      .th-label-box {
        position: relative;
        .label {
          gap: 65px;
        }
      }

      label {
        display: block;
        margin: 0;

        span {
          font-size: 14px;
        }
      }
    }
    tr {
      border-bottom: 0;
    }
    th,
    td {
      text-align: center;
    }

    td {
      .lead-detail {
        .text-wrap {
          flex-grow: 1;
        }

        label{
          margin: 0;
        }
      }
    }
  }
`;

export const StepsFormWrap = styled.div`
  position: relative;

  .tab-btns {
    display: flex;
    text-align: center;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 2px;
      background: #e6e7ec;
    }

    .btn {
      width: 50%;
      display: block;
      font-size: 16px;
      line-height: 20px;
      text-transform: capitalize;
      letter-spacing: 0.25px;
      padding: 18px 15px;
      text-align: center;
      color: #7f8594;
      margin: 0;
      border-bottom: 2px solid #e6e7ec;
      background: var(--white);

      &.active {
        color: var(--blue);
        border-bottom: 2px solid var(--blue);
        background: #e9f3fd;
      }
    }
  }

  .content-wrap {
    position: relative;
    padding: 20px 40px;
    z-index: 2;

    .col-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: var(--text-color);
      display: block;
      margin-bottom: 15px;
    }

    .fetch-details-btn {
      width: 100px;
      font-size: 12px;
      line-height: 16px;
      padding: 8px 10px;
      border-radius: 60px;
    }
  }

  .two-col {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 20px;

    @media (min-width: 576px) {
      grid-template-columns: 1fr 1fr;
    }

    .col {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      color: var(--primary);
      margin-bottom: 40px;
      span {
        display: block;
        margin-bottom: 10px;
      }
      .title {
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
      }
    }
  }

  .head {
    font-size: 16px;
    line-height: 20px;
    color: #9d9d9d;
    margin: 0 0 25px;

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      color: #313131;
      margin: 0 0 5px;
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);

    .btn-wrap {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 300px;
    }
  }
`;

export const MappingContacts = styled.div`
  ${({ $isLeadsStep }) =>
    $isLeadsStep &&
    css`
      position: relative;
      padding: 0 0 80px;
    `}

  .btn-holder {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);
  }
  .tab-btns {
    display: flex;
    text-align: center;
    position: relative;

    .btn {
      flex-grow: 1;
      font-size: 16px;
      line-height: 20px;
      text-transform: capitalize;
      letter-spacing: 0.25px;
      padding: 18px 15px;
      text-align: center;
      color: #7f8594;
      margin: 0;
      border-bottom: 2px solid #e6e7ec;
      background: var(--white);

      &.active {
        color: var(--blue);
        border-bottom: 2px solid var(--blue);
        background: #e9f3fd;
      }
    }
  }

  .edit-content-wrap {
    .form-area {
      .left-col {
        width: 100%;
      }

      .right-col {
        display: none;
      }

      .column-wrap {
        max-width: 780px;
        min-height: 550px;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        align-items: center;

        .head {
          font-size: 16px;
          line-height: 20px;
          color: #9d9d9d;
          margin: 0 0 25px;

          .heading {
            display: block;
            font-size: 25px;
            line-height: 28px;
            font-weight: 500;
            color: #313131;
            margin: 0 0 5px;
          }
        }
      }

      .edit-btn-holder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 15px;
        position: relative;
        border-top: 1px solid #e6e7ec;
        background: var(--white);

        &:before {
          display: none;
          content: "";
          position: absolute;
          bottom: 100%;
          left: 0;
          right: 0;
          height: 80px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            #f4f4f4 100%
          );
        }
      }
    }
  }
`;

export const LeadsDataStyle = styled.div`
  position: relative;
  color: #9d9d9d;

  .content-wrap {
    position: relative;
    padding: 20px 40px;
    z-index: 2;

    .checkbox-wrap {
      position: relative;

      label {
        color: #9d9d9d;
      }
    }
  }

  .head {
    font-size: 16px;
    line-height: 20px;
    color: #9d9d9d;
    margin: 0 0 25px;

    .heading {
      display: block;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
      color: #313131;
      margin: 0 0 5px;
    }
  }

  .data-holder {
    display: flex;
    flex-flow: wrap;
    gap: 20px;
    margin: 0 0 25px;

    .data-col {
      flex-grow: 1;
      padding: 20px;
      border-radius: 10px;
      border: 1px solid #efefef;
      background: #fefefe;

      &:nth-child(1),
      &:nth-child(2) {
        width: 48%;
      }
    }

    .value {
      display: block;
      font-size: 48px;
      line-height: 52px;
      font-weight: 600;
      color: #121212;
    }
    .subtitle {
      display: block;
      font-size: 16px;
      line-height: 20px;

      &.disabled {
        color: var(--text-color);
      }
    }
  }

  .check-text {
    color: #9d9d9d;
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    position: relative;
    border-top: 1px solid #e6e7ec;
    background: var(--white);

    &::before {
      display: none;
      content: "";
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #f4f4f4 100%
      );
    }

    .btn-wrap {
      width: 100%;
      max-width: 300px;
      display: flex;
      gap: 10px;

      ${({ $btnWrapJustifyBetween }) =>
    $btnWrapJustifyBetween &&
    css`
          max-width: 100%;
          justify-content: space-between;
        `}
    }
  }
`;

export const StyledSmallEditor = styled.div`
z-index:0 ;
  .tox-edit-area__iframe {
    padding: 10px !important;
    outline: none !important;

    body {
      padding: 0 !important;
    }

    .tox-edit-area {
      &:before {
        display: none !important;
      }
    }
  }
  .tox .tox-edit-area::before {
    display: none !important;
  }
`;

export const StyledEmailMessagePreviewModal = styled.section`
  form {
    display: flex;
  }

  .message-preview {
    width: 100%;
    padding: 30px;
  }

  .sidebar {
    width: 100%;
    max-width: 420px;
    padding: 30px 25px;
    border-right: 1px solid var(--gray-400);
    h2 {
      margin: 0 0 8px;
    }

    .text {
      display: block;
      margin: 0 0 20px;
    }

    textarea {
      resize: none;
      min-height: 80px;

      &::placeholder {
        color: var(--light-50);
      }
    }
  }
`;
